import React, { useState } from "react";

interface Props {
  initData?: string;
  isLastEntry?: boolean;
  removeAppointmentPolicy?: (index: number) => void;
  addAppointmentPolicy?: (desc: string) => void;
  updateAppointmentPolicy?: (index: number, value: string) => void;
  index?: number;
}

function AppointmentPolicy({
  initData,
  isLastEntry = true,
  addAppointmentPolicy,
  removeAppointmentPolicy,
  updateAppointmentPolicy,
  index,
}: Props) {
  const [desc, setDesc] = useState(initData ?? "");

  function handleAdd(e: React.MouseEvent) {
    e.preventDefault();
    if (desc !== initData && addAppointmentPolicy) {
      addAppointmentPolicy(desc);
      // Clear the form after adding
      setDesc("");
    }
  }

  const handleDescChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDesc = e.target.value;
    setDesc(newDesc);
    if (index && typeof index === "number" && updateAppointmentPolicy) {
      updateAppointmentPolicy(index, newDesc);
    }
  };

  return (
    <form className="flex gap-2">
      <div className="flex flex-col w-full gap-2">
        <div className="flex flex-col gap-2">
          <label className="text-xs">Description</label>
          <input
            className="w-full p-2 border-[2px] rounded-xl border-[#D9D9D9] bg-[#F7F7F7]"
            value={desc}
            onChange={handleDescChange}
            placeholder="Enter appointment policy description"
          />
        </div>
      </div>
      <div className="flex flex-col justify-end">
        {isLastEntry ? (
          <button
            className="p-2 px-4 rounded-lg bg-blue-900 text-white flex items-center justify-center"
            onClick={handleAdd}
          >
            +
          </button>
        ) : (
          <button
            onClick={(e) => {
              e.preventDefault();
              if (removeAppointmentPolicy && index) {
                removeAppointmentPolicy(index);
              }
            }}
            className="p-2 px-4 bg-red-900 rounded-lg text-white flex items-center justify-center"
          >
            -
          </button>
        )}
      </div>
    </form>
  );
}

export default AppointmentPolicy;
